import { Times } from '@octopus-do/octopus-storybook/icons'
import { artBoardActions } from '@store/reducers/artboard'
import type React from 'react'
import { useDispatch } from 'react-redux'

import css from './styles.module.css'

export const SidebarHeader: React.FC = () => {
  const dispatch = useDispatch()

  const handleCloseClick = () => {
    dispatch(
      artBoardActions.showAiChat({
        showAiChat: false,
      })
    )
  }

  return (
    <div className={css.sidebar_header}>
      <div className={css.sidebar_header_title}>Octopus Assistant</div>
      <button className={css.sidebar_header_button} onClick={handleCloseClick}>
        <Times />
      </button>
    </div>
  )
}
